module.exports = __webpack_public_path__ + "img/xufei.da46eb9d.png";